import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import lockr from 'lockr';
import axios from 'axios';
import { fetchApi, fetchApiAuth } from '../utils/api';
import { ResponseProps, Exam, DeleteResponseProps, GetExamResultsParams, SaveExamResultParams, SchoolExamResult, GetExamStatisticsParamsOrEmpty, ExamStatisticsResponse } from './types';
import constants from '../constants';

const {
    LOCALSTORAGE_EXPIRES_KEY,
    AUTH_KEY,
} = constants;

export const getExams = createAsyncThunk(
    'exam/get-exams',
    async (payload: any) => {
        try {
            const response:ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/exam/get-exams',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const updateExam = createAsyncThunk(
    'exam/update-exam',
    async (payload:Exam) => {
        try {
            const response:ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/exam/update-exam',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const createExam = createAsyncThunk(
    'exam/create-exam',
    async (payload:Exam) => {
        try {
            const response:ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/exam/create-exam',
                body: payload,
            });
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const deleteExam = createAsyncThunk(
    'exam/delete-exam',
    async (payload: { id: number }) => {
        try {
            await fetchApiAuth({
                method: 'POST',
                url: 'v1/exam/delete-exam',
                body: payload,
            });
            return payload;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const getExamResults = createAsyncThunk(
    'exam/get-exam-results',
    async (params: GetExamResultsParams) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/exam/get-exam-results',
                body: params,
            });
            return response.data.results || [];
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Klaida',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const saveExamResult = createAsyncThunk(
    'exam/save-exam-result',
    async (params: SaveExamResultParams) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/exam/save-exam-result',
                body: params,
            });
            return response.data.results;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Klaida',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const deleteExamResult = createAsyncThunk(
    'exam/delete-exam-result',
    async (payload: { id: number }) => {
        try {
            await fetchApiAuth({
                method: 'POST',
                url: 'v1/exam/delete-exam-result',
                body: payload,
            });
            return payload;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Klaida',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const getExamStatistics = createAsyncThunk(
    'exam/get-exam-statistics',
    async (payload: any) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/exam/get-exam-statistics',
                body: payload,
            });
            return response.data.statistics;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Klaida',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);
